import { Navigate, useParams } from 'react-router-dom';
import useObjectDefinitions from '../hooks/useObjectDefinitions';

/**
 * Redirects legacy /crm/objects/:objectDefinitionId[/records/:recordId]
 * to the new /data/:slug_plural[/:recordId] routes.
 */
export default function DataObjectIdRedirect() {
  const { objectDefinitionId, recordId } = useParams();
  const { loading, getById, getObjectPath, getRecordPath } = useObjectDefinitions();

  if (loading) return null;

  const match = getById(objectDefinitionId);
  if (match) {
    const target = recordId ? getRecordPath(match, recordId) : getObjectPath(match);
    return <Navigate to={target} replace />;
  }
  return <Navigate to="/data/companies" replace />;
}
